import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { doSignOut } from "../../firebase/auth";
import { useAuth } from "../../contexts/authContext";
import "./Navbar.css";
import logo from "../../assets/logo.jpg";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu"; 

const Navbar = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user is an admin
  useEffect(() => {
    const checkAdmin = async () => {
      if (currentUser?.role === "admin") {
        setIsAdmin(true);
      }
    };
    checkAdmin();
  }, [currentUser]);

  const handleLogout = () => {
    doSignOut().then(() => {
      navigate("/");
    });
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAdminDashboard = () => {
    navigate("/admin-dashboard");
    handleMenuClose();
  };

  // Check if current page is 'user/orderId'
  const isUserPage = location.pathname.includes("/user/");

  return (
    <nav className="navbar">
      <div className="navbar-content">
        {/* Logo */}
        <img src={logo} alt="Logo" className="navbar-logo" />

        {/* Title */}
        <div className="navbar-title">BMS Dashboard</div>

        {/* Conditional Admin Menu or Logout Button */}
        {isAdmin && isUserPage ? (
          <>
            {/* Menu icon for admin */}
            <IconButton onClick={handleMenuOpen}>
              <MenuIcon style={{ color: "white" }} />
            </IconButton>

            {/* Admin Menu */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleAdminDashboard}>Admin Dashboard</MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </>
        ) : (
          // Logout button for normal users
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
